<template>
  <i aria-hidden="true" aria-role="presentation" :aria-label="name.toUpperCase()" :class="[baseCss, svg ? 'em-svg' : 'em', `em-${name}`, 'select-none']" :style="{fontSize: `${size}em`}" />
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'Emoji',
  mixins: [
    methods
  ],
  data () {
    return {
      baseCss: this.componentBaseCss('emoji', [])
    }
  },
  props: {
    name: {
      type: String,
      default: 'smile'
    },
    size: {
      type: Number,
      default: 1.5
    },
    svg: {
      type: Boolean,
      default: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/bcq-ui/components/emoji/emoji.vue